import { j as r } from "./index.es33.js";
import { memo as e } from "react";
import { Typography as p } from "./index.es35.js";
import "./index.es36.js";
import { periods as i } from "./index.es641.js";
import m from "./index.es527.js";
var f = /*#__PURE__*/e(function (_ref) {
  var s = _ref.onSelect;
  return r.jsx("div", {
    className: m.periodWrapper,
    children: i.map(function (o) {
      return r.jsx(p.Body2, {
        className: m.period,
        as: "button",
        onClick: function onClick() {
          return s === null || s === void 0 ? void 0 : s(o.handler());
        },
        children: o.label
      }, o.key);
    })
  });
});
export { f as Periods };